import { render, staticRenderFns } from "./BillType.vue?vue&type=template&id=40abd9a5&scoped=true"
import script from "./BillType.vue?vue&type=script&lang=js"
export * from "./BillType.vue?vue&type=script&lang=js"
import style0 from "./BillType.vue?vue&type=style&index=0&id=40abd9a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40abd9a5",
  null
  
)

export default component.exports